import { ApiError } from "@/lib/api";

/**
 * The server's own reason when it gives one — DRF's `detail`, or the first
 * field error (the create endpoint answers `{"items": [...]}` when none of the
 * ticked issues can be used) — else a plain retry line.
 */
export function createErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.body && typeof error.body === "object") {
    const body = error.body as Record<string, unknown>;
    if (typeof body.detail === "string") return body.detail;
    for (const value of Object.values(body)) {
      if (typeof value === "string") return value;
      if (Array.isArray(value) && typeof value[0] === "string") return value[0];
    }
  }
  return "Couldn't create the report. Try again.";
}
